import { $t } from '@/plugins/app/_config/main'

export default {
	parseErrors(errors) {
		// @ts-expect-error
		return Object.values(errors).map(error => $t(error?.$message)).join('. ')
	}
}